import { css } from "@emotion/react";
import theme from "./index";

const global = css`
  @import url("https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,400;0,700;1,400&display=swap");

  html,
  body {
    box-sizing: border-box;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-size: 62.5%;
    font-family: "Roboto Mono", -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Helvetica Neue", sans-serif;
    background: ${theme.colors.black};
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    color: ${theme.colors.white};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.8rem;
    line-height: 1.75em;
  }
  #root {
    box-sizing: border-box;
    height: 100%;
  }
`;

export default global;
